import type { SVGProps } from 'react';
import { useId } from 'react';
import ZepIcon from '../ZepIcon';
export const BoltSmallRectangleColorMintIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();
  return <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path fill={`url(#${gradientId})`} fillRule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm7.778 3.018c.159.049.266.189.266.347v4.018h3.571c.145 0 .277.077.343.2a.35.35 0 0 1-.032.38l-5.274 6.887a.4.4 0 0 1-.43.132.37.37 0 0 1-.266-.347v-4.018H7.385a.39.39 0 0 1-.343-.2.35.35 0 0 1 .032-.38l5.274-6.887a.4.4 0 0 1 .43-.132" clipRule="evenodd" />
        <defs>
          <linearGradient id={gradientId} x1={3} x2={21} y1={12} y2={12} gradientUnits="userSpaceOnUse">
            <stop stopColor="#18D0B4" />
            <stop offset={1} stopColor="#3CD84C" />
          </linearGradient>
        </defs>
      </svg>;
});